var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Projects',{attrs:{"no-filter":"","tab":"","query":{ batteryId: _vm.battery.id },"limit":5}})
}
var staticRenderFns = []

export { render, staticRenderFns }